import Vue from "vue";
import Router from "vue-router";
import { authValid } from "./axios";

Vue.use(Router);

const AdminRouters = [
  {
    path: "/admin",
    component: () =>
      import(/* webpackChunkName: "admin_layout" */ "./views/admin/Layout"),
    children: [
      {
        path: "",
        name: "admin",
        redirect: "/admin/releases"
      },
      {
        path: "users",
        name: "admin_users",
        meta: {
          authRequire: true
        },
        component: () =>
          import(/* webpackChunkName: "admin_users" */ "./views/admin/Users.vue")
      },
      {
        path: "password",
        name: "change_password",
        meta: {
          authRequire: true
        },
        component: () =>
          import(/* webpackChunkName: "change_password" */ "./views/admin/ChangePassword.vue")
      },
      {
        path: "repos",
        name: "admin_repos",
        meta: {
          authRequire: true
        },
        component: () =>
          import(/* webpackChunkName: "admin_repos" */ "./views/admin/Repos.vue")
      },
      {
        path: "repos/draft",
        name: "admin_repos_draft",
        meta: {
          authRequire: true
        },
        component: () =>
          import(/* webpackChunkName: "admin_repos_draft" */ "./views/admin/ReposDraft.vue")
      },
      {
        path: "repos/:repo_id/edit",
        name: "admin_repo_edit",
        meta: {
          authRequire: true
        },
        component: () =>
          import(/* webpackChunkName: "admin_repo_edit" */ "./views/admin/RepoEdit.vue")
      },
      {
        path: "releases",
        name: "admin_releases",
        meta: {
          authRequire: true
        },
        component: () =>
          import(/* webpackChunkName: "admin_releases" */ "./views/admin/Releases.vue")
      },
      {
        path: "releases/draft",
        name: "admin_releases_draft",
        meta: {
          authRequire: true
        },
        component: () =>
          import(/* webpackChunkName: "admin_releases_draft" */ "./views/admin/ReleasesDraft.vue")
      },
      {
        path: "releases/:release_id/edit",
        name: "admin_release_edit",
        meta: {
          authRequire: true
        },
        component: () =>
          import(/* webpackChunkName: "admin_release_edit" */ "./views/admin/ReleaseEdit.vue")
      },
      {
        path: "nodes",
        name: "admin_nodes",
        meta: {
          authRequire: true
        },
        component: () =>
          import(/* webpackChunkName: "admin_nodes" */ "./views/admin/Nodes.vue")
      }
    ]
  }
];

const router = new Router({
  routes: [
    ...AdminRouters,
    {
      path: "/",
      redirect: "/admin"
    },
    {
      path: "/register",
      name: "register",
      component: () =>
        import(/* webpackChunkName: "register" */ "./views/Register.vue")
    },
    {
      path: "/login",
      name: "login",
      component: () =>
        import(/* webpackChunkName: "login" */ "./views/Login.vue")
    },
    {
      path: "/releases",
      name: "releases",
      component: () =>
        import(/* webpackChunkName: "releases" */ "./views/Releases.vue")
    },
    {
      path: "/repos",
      name: "repos",
      component: () =>
        import(/* webpackChunkName: "repos" */ "./views/Repos.vue")
    },
    {
      path: "/repos/:repo_id",
      name: "repo_preview",
      component: () =>
        import(/* webpackChunkName: "repo_preview" */ "./views/RepoPreview.vue")
    },
    {
      path: "/releases/:release_id",
      name: "release_preview",
      component: () =>
        import(/* webpackChunkName: "release_preview" */ "./views/ReleasePreview.vue")
    },
    {
      path: "*",
      redirect: "/admin"
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.meta.authRequire) {
    authValid(to, from, next);
  }
  next();
});

export default router;
